export const BASE_URL = "https://globalfolio.heva.la"
export const API_VERSION = "v1"
export const API_URL = `${BASE_URL}/api/${API_VERSION}`